import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import ObjectPage from './screens/ObjectPage/ObjectPage';
import Produits from './screens/ProduitsPage/Produits';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter scrollToTop={true}>
        <Routes>
          <Route path='/annonce' element={<ObjectPage />}/>
          <Route path='/produits' element={<Produits />} />
          <Route path='/' element={<App />} />
          <Route path='*' element={<App />} />
        </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
